import React, { Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { AppContext } from '../../AppContext';

const Footer = () => {
    const { appState } = useContext(AppContext);
    const { footer } = appState;
    const { links, locations, banners, tweets, newsletter, socials, copyright, image } = footer || {};

    const settings = {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        vertical: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 3000,
        cssEase: 'linear',
        pauseOnHover: true
    };

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    return (
        <Fragment>
            <footer className="bg-black section-padding footer">
                <div className="container">
                    <div className="row">
                        {/* Useful Links */}
                        <div className="col-lg-3 col-sm-6">
                            <div className="footer-box mb-md-80">
                                <div className="footer-heading">
                                    <h4 className="text-custom-white no-margin">Useful Links</h4>
                                </div>
                                <ul className="custom links">
                                    {links?.map((item, i) => (
                                        <li key={i}><div onClick={() => {
                                            window.open(item.to, '_self')
                                        }} className="text-custom-white">{item.label}</div></li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Featured Posts */}
                        <div className="col-lg-4 col-sm-6">
                            <div className="footer-box mb-md-80">
                                <div className="footer-heading">
                                    <h4 className="text-custom-white no-margin">Locations</h4>
                                </div>
                                <ul className="custom popular_post">
                                    {locations?.map((item, i) => (
                                        <li key={i}>
                                            <div clxassName="post">
                                                <div className="post-wrapper">
                                                    <div className="popular_post_img animate-img">
                                                        <Link to={'/'
                                                            // `/blog-single/${item.id}`
                                                        }>
                                                            <img src={item.image} className="img-fluid image-fit" alt={item.address} style={{
                                                                // height: 100,
                                                                // width: 'auto',
                                                                // objectFit: 'contain'
                                                                height: 200,           // double the previous size
                                                                width: 'auto',
                                                                objectFit: 'contain',
                                                                display: 'block',      // ensures no inline spacing
                                                                maxWidth: 'none'
                                                            }} />
                                                        </Link>
                                                    </div>
                                                    <div className="popular_post_title">
                                                        <h6><Link to={'/'
                                                            // `/blog-single/${item.id}`
                                                        } className="text-custom-white fs-14 fw-400">{item.address}</Link></h6>
                                                        <div className="post-date">
                                                            <p className="text-white no-margin">{item.postcode}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Featured Posts */}
                        <div className="col-lg-4 col-sm-6">
                            <div className="footer-box mb-md-80">
                                <div className="footer-heading">
                                    <h4 className="text-custom-white no-margin">{banners?.[0]?.message}</h4>
                                </div>
                                <ul className="custom popular_post">
                                    {banners?.map((item, i) => (
                                        <li key={i}>
                                            <div clxassName="post">
                                                <div className="post-wrapper">
                                                    <div className="popular_post_img animate-img">
                                                        <Link to={'/'
                                                            // `/blog-single/${item.id}`
                                                        }>
                                                            <img src={item.image} className="img-fluid image-fit" alt={'item.message'} style={{
                                                                // height: 100,
                                                                // width: 'auto',
                                                                // objectFit: 'contain'
                                                                height: 200,           // double the previous size
                                                                width: 'auto',
                                                                objectFit: 'contain',
                                                                display: 'block',      // ensures no inline spacing
                                                                maxWidth: 'none'
                                                            }} />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Twitter Feeds */}
                        {/* <div className="col-lg-3 col-sm-6">
                            <div className="footer-box mb-xs-80">
                                <div className="footer-heading">
                                    <h4 className="text-custom-white no-margin">Twitter Feeds</h4>
                                </div>
                                <Slider className="custom twitter-feed twitter-slider" {...settings}>
                                    {tweets.map((tweet, i) => (
                                        <li key={i}>
                                            <p className="tweet">{tweet.tweet} <Link to={tweet.link}>{tweet.link}</Link></p>
                                            <p className="timePosted"><Link to={tweet.link}>Posted on {tweet.tweetdate}</Link></p>
                                        </li>
                                    ))}
                                </Slider>
                            </div>
                        </div> */}

                        {/* Newsletter */}
                        {/* <div className="col-lg-3 col-sm-6">
                            <div className="footer-box">
                                <div className="footer-heading">
                                    <h4 className="text-custom-white no-margin">News Letter</h4>
                                </div>
                                <div className="newsletter">
                                    <form>
                                        <div className="form-group">
                                            <input type="email" className="form-control form-control-custom" placeholder={newsletter.placeholder} />
                                        </div>
                                        <button className="btn-first btn-submit-fill btn-height full-width" type="submit">{newsletter.button}</button>
                                    </form>
                                </div>
                                <div className="social-media">
                                    <ul className="custom social-media">
                                        {socials.map((icon, i) => (
                                            <li key={i}><Link to="#"><i className={`fab fa-${icon}`} /></Link></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>
            </footer>

            {/* Copyright */}
            <div className="copyright">
                <div className="container">
                    <div className="row">
                        {/* <div className="col-lg-6">
                            <div className="payment-logo mb-md-20">
                                <span className="text-custom-white fs-14 mr-3">We are accept</span>
                                <div className="payemt-icon">
                                    <img src={process.env.PUBLIC_URL + image} alt="payment" />
                                </div>
                            </div>
                        </div> */}
                        <div className="col-lg-6">
                            <p className="text-custom-white no-margin">
                                {copyright?.text} <Link to="#" className="text-custom-white">{copyright?.credit}</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Back to Top */}
            <div id="back-top" className="back-top d-block">
                <Link to="#" onClick={scrollToTop}><i className="flaticon-up-arrow" /></Link>
            </div>
        </Fragment>
    );
};

export default Footer;
